<template>
    <div class="inline-block" :class="{ 'text-xl': size == 'large' }">
        <a href="https://www.kiyoh.com/reviews/1043691/doorax" class="text-gray-800 hover:text-gray-600 flex items-center" target="_blank">
            <KiyohLogo />

            <div class="block">
                <div class="text-xs text-dgreen2 inline-block">
                    <fa :icon="['fas', 'star']" class="h-4 md:h-3 inline-block" />
                    <fa :icon="['fas', 'star']" class="h-4 md:h-3 inline-block" />
                    <fa :icon="['fas', 'star']" class="h-4 md:h-3 inline-block" />
                    <fa :icon="['fas', 'star']" class="h-4 md:h-3 inline-block" />
                    <fa :icon="['fas', 'star-half']" class="h-4 md:h-3 inline-block" />
                </div>
                <span class="text-md font-bold ml-1 text-dblue"> {{ $appStore.kiyoh.score }} </span>
                <span class="w-full block text-gray-600 text-sm md:text-xs text-right">{{ $appStore.kiyoh.reviews }} {{ $t('beoordelingen') }}</span>
            </div>
        </a>
    </div>
</template>

<script setup>
import KiyohLogo from '@/Blocks/KiyohLogo.vue';

defineProps({
    size: String,
});
</script>
